import React, { useEffect, useRef, useState } from 'react';

import gogglesBackView from '../../../main/assets/images/fpvonepilot/goggles-back-view.webp';

export const Silent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const currentRef = sectionRef.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, 1000);
        }
      },
      { threshold: 0.8 },
    );

    observer.observe(currentRef);

    return () => {
      observer.unobserve(currentRef);
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`fpv-pilot-silent-section ${isVisible ? 'visible' : ''}`}
    >
      <div className="fpv-pilot-silent-content">
        <div className="fpv-pilot-silent-text">
          <div className="fpv-pilot-silent-titles">
            <h3 className="fpv-pilot-silent-subtitle">Technology</h3>
            <h2 className="fpv-pilot-silent-title">
              Silent and cooler than ever
            </h2>
          </div>
          <p className="fpv-pilot-silent-description">
            Automatic defogging of optics engines. Instantly, without a breeze.
          </p>
        </div>
        <div className="fpv-pilot-silent-image">
          <img
            src={gogglesBackView}
            alt="Rear View of the Headset, Showing the Optics."
            className="fpv-pilot-silent-product"
          />
        </div>
      </div>
    </section>
  );
};
